import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

import { FormattedMessage } from 'react-intl';

import { PdpSharedDescriptionContent } from './PdpSharedDescriptionContent';

import { PdpSharedContactDealerButton } from '../PdpSharedButtons/PdpSharedContactDealerButton';

import classNames from 'classnames';

import styles from './PdpSharedDescription.scss';

export const Title = () => (
    <FormattedMessage
        id="PdpSharedDescriptionAdditionalOptions.customizationHeader"
        defaultMessage="Additional Options"
    />
);
const PdpSharedDescriptionAdditionalOptionsContentComponent = ({
    customizationOptions,
    contentClass,
    buttonClass,
    item,
    user,
    isFullWidthCta = false,
}) => (
    <PdpSharedDescriptionContent
        collapsedHeight={120}
        buttonClass={classNames(styles.button, buttonClass)}
    >
        <span className={classNames(styles.content, contentClass)}>{customizationOptions}</span>
        <div className={styles.ctaWrapper}>
            <PdpSharedContactDealerButton
                size="small"
                fullWidth={isFullWidthCta}
                buttonType="secondary"
                type={'REQUEST_CUSTOMIZATION'}
                item={item}
                user={user}
            />
        </div>
    </PdpSharedDescriptionContent>
);

PdpSharedDescriptionAdditionalOptionsContentComponent.propTypes = {
    customizationOptions: PropTypes.string,
    contentClass: PropTypes.string,
    buttonClass: PropTypes.string,
    item: PropTypes.object,
    user: PropTypes.object,
    isFullWidthCta: PropTypes.bool,
};

export const PdpSharedDescriptionAdditionalOptionsContent = createFragmentContainer(
    PdpSharedDescriptionAdditionalOptionsContentComponent,
    {
        user: graphql`
            fragment PdpSharedDescriptionAdditionalOptionsContent_user on User {
                ...PdpSharedContactDealerButton_user
            }
        `,
        item: graphql`
            fragment PdpSharedDescriptionAdditionalOptionsContent_item on Item {
                ...PdpSharedContactDealerButton_item
            }
        `,
    }
);
